export default "<ion-button (click)=\"back()\" fill=\"clear\">\n  <ion-icon color=\"light\" name=\"arrow-back\"></ion-icon>\n</ion-button>";